import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext } from "react"
import { AppContext } from "Views/Home/context"
import { CalendarContext, SelectDateRange } from "../context"
import cal from "clsx"
import { checkWeiboAdPlace } from "../EmptyItem"
import { AdPlace } from "Types/place"
import { Board } from "Types/board"

const useStyles = makeStyles(() => ({
    timeBlock: {
        width: "100%",
        borderBottom: "1px solid #ddd",
        borderRight: "1px solid #ddd",
        minHeight: 50,
        position: "relative",
    },
    pass: {
        backgroundColor: "rgba(0,0,0,.1)",
    },
}))
interface ComponentProps {
    place: AdPlace,
    d: Date,
    children: React.ReactNode,
    boardMap: { [keys: number]: Board },
    addLocked: boolean,
    toggle: (value: boolean) => void,
}
let addTimer: number | null = null
const addTime = 200
const SelectItem = (props: ComponentProps) => {
    const { place, d, children, boardMap, addLocked, toggle } = props
    const classes = useStyles()
    const {
        selectPlaceId, handleChangeSelectPlaceId,
        handleSetSelectDateRange, selectDateRange,
        privilege, isWeibo, channelName
    } = useContext(CalendarContext)
    const { user } = useContext(AppContext)
    const isPass = new Date().getTime() - (24 * 3600 * 1000) > d.getTime()
    const disabled = isWeibo && !checkWeiboAdPlace(user, place)
    const handleMouseEnter = () => {
        if (selectPlaceId) {
            if (boardMap[place.id + d.getTime()]) {
                toggle(true)
            } else {
                if (!addLocked) {
                    handleSetSelectDateRange({
                        ...(selectDateRange as SelectDateRange),
                        end: d,
                    })
                }
            }
        }
    }
    const handleMouseDown = () => {
        if (isPass || !privilege.insert) {
            return
        }
        if (isWeibo && !checkWeiboAdPlace(user, place)) {
            return
        }
        if (['吃货', '童学馆', '美丽', '果壳视频', '摄影'].includes(channelName)) return
        if (!boardMap[place.id + d.getTime()]) {
            addTimer = window.setTimeout(() => {
                handleChangeSelectPlaceId(place.id)
                handleSetSelectDateRange({
                    ...selectDateRange,
                    start: d,
                    end: d,
                })
            }, addTime)
        }
    }
    const handleMouseUp = () => {
        window.clearTimeout(addTimer as number)
    }
    return (
        <div
            className={
                cal(
                    classes.timeBlock,
                    (disabled || isPass) && classes.pass,
                )
            }
        // 取消拖拽多选功能
        // onMouseEnter={handleMouseEnter}
        // onMouseDown={handleMouseDown}
        // onMouseUp={handleMouseUp}
        >
            {children}
        </div>
    )
}

export default SelectItem
